// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"631c294b","703":"28338baa"}[chunkId] + ".chunk.js";
};